import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { IconButton, Tabs } from 'shared/ui'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { type IResponseVoice } from 'entities/TextToSpeech'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type TextToSpeechVoiceConfigDefault } from 'widgets/TextToSpeech/ui/TextToSpeechVoice/store/TextToSpeechVoiceConfigDefault'
import { VoicesContent } from 'widgets/TextToSpeech/ui/TextToSpeechVoice/VoicesContent/VoicesContent'

export const DefaultVoiceContent = observer(
  ({ store, onCloseMenu }: { store: TextToSpeechVoiceConfigDefault; onCloseMenu: () => void }) => {
    const {
      loadVoices,
      search,
      setSearch,
      tabs,
      activeTabKey,
      isCreateCustomVoice,
      handleSelectTab,
      voices,
      onCreateCustomVoice,
      onDeleteCustomVoice,
      getVoicePreview,
      onErrorLoadPreview,
    } = store
    useEffect(() => {
      loadVoices()
      return () => setSearch('')
    }, [])

    const { textToSpeechStore } = useEntitiesContext()

    const handleCreateCustomVoice = () => {
      onCloseMenu()
      onCreateCustomVoice()
    }
    return (
      <VoicesContent
        onCloseMenu={onCloseMenu}
        search={search}
        setSearch={setSearch}
        tabContent={
          <Tabs tabs={tabs} activeTabKey={activeTabKey} handleSelectTab={handleSelectTab} />
        }
        voices={voices}
        bottomContent={
          isCreateCustomVoice && (
            <TextFieldPlaceholder
              leftActions={[
                makeTextFieldIcon({
                  icon: 'add',
                  margin: 0,
                }),
              ]}
              placeholder={'Create custom voice'}
              size={'small'}
              variant={'outline'}
              onClick={handleCreateCustomVoice}
            />
          )
        }
        voiceItemProps={(voice: IResponseVoice) => ({
          rightContent: activeTabKey === 'custom' && (
            <IconButton
              ariaLabel={'delete'}
              icon={'delete'}
              size={'small'}
              variant={'icon'}
              color={'tertiary'}
              tooltipProps={{
                label: 'Delete',
                placement: 'top',
              }}
              onClick={(e) => {
                e.stopPropagation()
                onCloseMenu()
                onDeleteCustomVoice(voice.id)
              }}
            />
          ),
          getVoicePreview,
          onErrorLoadPreview,
          isLoading: !!textToSpeechStore.loadingPreviewMap.get(voice.id),
        })}
      />
    )
  }
)
